import { debounce } from 'underscore';
var { LayoutView } = require('backbone.marionette');


export const SearchView = LayoutView.extend({
  template: require('../templates/search/index.html'),
  className: 'filter',

  ui: {
    searchbox: 'input.filter'
  },

  events: {
    'keyup @ui.searchbox': 'search',
    'blur @ui.searchbox': 'search'
  },

  initialize() {
    this.options.runSearch = debounce(
      () => this.collection.search(this.ui.searchbox.val()),
      300
    );
  },

  search() {
    this.getOption('runSearch')();
  }
});



// WEBPACK FOOTER //
// ./base/views/search.js